import React from "react";
import { StyledButton } from "@aureskonnect/react-ui";

export function CustomSecondaryColorButton(props: any) {
    return <StyledButton {...props} rounded variant="light" outline />;
}
